'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import WarningIcon from './WarningIcon';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onChangeAcceptance: PropTypes.func.isRequired,
    distributionRestrictedActivities: PropTypes.array,
}

const defaultProps = {
    children: null,
    className: '',
    distributionRestrictedActivities: null,
};

function DistributionRestrictionWarningBox(props) {
    function _onChange(e) {
        props.onChangeAcceptance(e.target.checked);
    }

    return (
      <div className={`error-box alert alert-warning ${props.className}`} role="alert">
        <WarningIcon className="margin-right-sm" />
        <span className="sr-only">Warning:</span>
        <span>
            {!!props.distributionRestrictedActivities ?
                'There are activities being duplicated or moved that have restricted distribution rights:'
                :
                'The activity being duplicated or moved has restricted distribution rights.'
            }
        </span>
        <br />
        {!!props.distributionRestrictedActivities &&
            <ul className="restrictedList">
                {props.distributionRestrictedActivities.map((act) =>
                    <li key={act.id}>{act.meta_data.title}</li>
                )}
            </ul>
        }
        <input id="restricted-warn-ack" type="checkbox" onChange={_onChange} />
        <label htmlFor="restricted-warn-ack"> I understand that this content contains restricted materials.</label>
      </div>
    );
}

DistributionRestrictionWarningBox.propTypes = propTypes;
DistributionRestrictionWarningBox.defaultProps = defaultProps;

export default DistributionRestrictionWarningBox;